<div class="parking-type-item flex items-center justify-between gap-3 px-3 py-2.5 hover:bg-slate-50 transition-colors">
    <!-- Left Side: Type Info -->
    <div class="flex items-center gap-3 min-w-0">
        <!-- Type Icon — for an Easypass row with a token, this doubles as a "Redeem" shortcut
             straight to the parker app, rather than a purely decorative badge. -->
        @if (typeCategory === 'easypass' && getRedeemLink()) {
        <a [href]="getRedeemLink()" target="_blank" rel="noopener" matTooltip="Redeem in parker app"
            class="type-icon shrink-0 bg-violet-50 text-violet-600 hover:bg-violet-100 transition-colors cursor-pointer">
            <mat-icon class="!w-4 !h-4 !text-[16px] leading-4">qr_code</mat-icon>
        </a>
        } @else {
        <div class="type-icon shrink-0" [ngClass]="{
                'bg-amber-50 text-amber-600': typeCategory === 'default-exemption',
                'bg-rose-50 text-rose-600': typeCategory === 'custom-exemption',
                'bg-emerald-50 text-emerald-600': typeCategory === 'assigned-zone-parkers',
                'bg-blue-50 text-blue-600': typeCategory === 'pool-parking',
                'bg-violet-50 text-violet-600': typeCategory === 'easypass'
            }">
            <mat-icon class="!w-4 !h-4 !text-[16px] leading-4">
                @switch (typeCategory) {
                @case ('default-exemption') { verified_user }
                @case ('custom-exemption') { security }
                @case ('assigned-zone-parkers') { person_pin }
                @case ('pool-parking') { groups }
                @case ('easypass') { qr_code }
                }
            </mat-icon>
        </div>
        }

        <!-- Type Details -->
        <div class="min-w-0">
            <div class="flex items-center gap-2">
                <h4 class="text-sm font-semibold text-slate-900 truncate">{{ getTypeName() }}</h4>
                <jjames-badge [variant]="getTypeBadgeVariant()">{{ getTypeCategoryName() }}</jjames-badge>
            </div>

            <div class="flex flex-wrap items-center gap-x-3 gap-y-0.5 mt-0.5 text-xs text-slate-500">
                <!-- Availability (high-contrast status) -->
                <span class="inline-flex items-center gap-1 font-medium text-slate-700">
                    <mat-icon class="!w-3.5 !h-3.5 !text-[14px] leading-[14px]">schedule</mat-icon>
                    {{ getAvailabilityText() }}
                </span>

                @if (getAdditionalInfo()) {
                <span class="inline-flex items-center gap-1">
                    <mat-icon class="!w-3.5 !h-3.5 !text-[14px] leading-[14px]">info</mat-icon>
                    {{ getAdditionalInfo() }}
                </span>
                }

                @if (parkingType?.availableForParkingZones && parkingType!.availableForParkingZones!.length > 0) {
                <span class="inline-flex items-center gap-1">
                    <mat-icon class="!w-3.5 !h-3.5 !text-[14px] leading-[14px]">location_on</mat-icon>
                    {{ parkingType!.availableForParkingZones!.length }} zone(s)
                </span>
                }

                @if (getOperatorName()) {
                <span class="inline-flex items-center gap-1">
                    <mat-icon class="!w-3.5 !h-3.5 !text-[14px] leading-[14px]">badge</mat-icon>
                    {{ getOperatorName() }}
                </span>
                }

                @if (getOrganizationName()) {
                <span class="inline-flex items-center gap-1">
                    <mat-icon class="!w-3.5 !h-3.5 !text-[14px] leading-[14px]">business</mat-icon>
                    {{ getOrganizationName() }}
                </span>
                }

                @if (getCostCenterName()) {
                <span class="inline-flex items-center gap-1">
                    <mat-icon class="!w-3.5 !h-3.5 !text-[14px] leading-[14px]">payments</mat-icon>
                    {{ getCostCenterName() }}
                </span>
                }
            </div>
        </div>
    </div>

    <!-- Right Side: Actions -->
    <div class="flex items-center gap-1 shrink-0">
        <button type="button" (click)="onDelete()" [disabled]="isDeleting()" matTooltip="Remove from parking space"
            class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-slate-400 hover:bg-rose-50 hover:text-rose-600 transition-colors disabled:opacity-50">
            @if (isDeleting()) {
            <mat-spinner diameter="18"></mat-spinner>
            } @else {
            <mat-icon class="!w-5 !h-5 !text-[20px] leading-5">delete_outline</mat-icon>
            }
        </button>
    </div>
</div>